/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Lead_ListInputs */

const es_landing_hero_lead_list = /** @type {(inputs: Landing_Hero_Lead_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista séptima`)
};

const gl_landing_hero_lead_list = /** @type {(inputs: Landing_Hero_Lead_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista sétima`)
};

const en_landing_hero_lead_list = /** @type {(inputs: Landing_Hero_Lead_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seventh List`)
};

/**
* | output |
* | --- |
* | "Seventh List" |
*
* @param {Landing_Hero_Lead_ListInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_hero_lead_list = /** @type {((inputs?: Landing_Hero_Lead_ListInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Lead_ListInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_hero_lead_list(inputs)
	if (locale === "en") return en_landing_hero_lead_list(inputs)
	return es_landing_hero_lead_list(inputs)
});